export const PROXY_ITEM_ELEMENT_SEMI_TRANSPARENCY = 0.5;
export const PROXY_SELECTOR_PLACEHOLDER_MIN_WIDTH = 169;
